namespace $.$$ {

	export class $shm_hitalama_version_label extends $.$shm_hitalama_version_label {

		title() {
			return `v${ this.version() } (${ this.date() })`
		}

	}

}
